import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Radio,
  Box,
} from '@mui/material';

const GpuClass = (props) => {
  const { name, price, performance, id } = props.details;
  const disabled = false;

  const handleClick = () => {
    if (!disabled && props.onClick) {
      props.onClick(id);
    }
  };

  return (
    <Card
      id={id}
      onClick={handleClick}
      sx={{
        cursor: disabled ? 'default' : 'pointer',
        border: props.selected
          ? '2px solid'
          : '1px solid',
        borderColor: props.selected
          ? 'secondary.main'
          : 'divider',
        backgroundColor: props.selected
          ? 'action.selected'
          : 'background.paper',
        '&:hover': disabled
          ? {}
          : {
              borderColor: 'secondary.main',
              boxShadow: 2,
            },
      }}
    >
      <CardContent>
        <Typography variant='h6' component='div' sx={{ mb: 1 }}>
          {name}
        </Typography>

        <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
          Credits Per Hour:{' '}
          {price.max === price.min
            ? price.max
            : `${price.min} - ${price.max}`}
        </Typography>

        <Box>
          <Typography variant='body2' sx={{ mb: 0.5 }}>
            {performance.memory_size} GB GPU RAM
          </Typography>
          <Typography variant='body2' sx={{ mb: 0.5 }}>
            {performance.fp32_rate} TFLOPS (fp32)
          </Typography>
          <Typography variant='body2' sx={{ mb: 0.5 }}>
            {performance.fp16_rate} TFLOPS (fp16)
          </Typography>
        </Box>
      </CardContent>
      <CardContent sx={{ textAlign: 'center', pt: 0 }}>
        <Radio checked={props.selected} readOnly />
      </CardContent>
    </Card>
  );
};

export default GpuClass;

